import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mydesk.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-page-mydesk-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mydesk.mypage/view.scss */
.content-page-header {
  display: flex;
  align-items: center;
  padding: 18px 16px;
  padding-top: 0;
}
.content-page-header * {
  margin: 0;
  line-height: 1;
}

.card-body {
  border: none;
}

.alert {
  font-size: 16px;
}

.wiz-form {
  background-color: #fff;
}
.wiz-form .wiz-form-label {
  font-size: 0.875rem;
}
.wiz-form .form-control {
  padding: 0.5625rem 0.75rem;
  font-size: 0.875rem;
}

.wiz-form .wiz-form-rows:first-child {
  border-top: none;
}

.wiz-form .wiz-form-rows:last-child {
  border-bottom: none;
}`],
})
export class PageMydeskMypageComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/auth/login");
        await this.load();
    }

    public async alert(message: string, status: any = "error") {
        return await this.service.alert.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: "확인",
            status: status
        });
    }

    public async load() {
        const { data } = await wiz.call("session");
        let { user, group } = data;
        try {
            if (user.birth) user.birth = moment(user.birth).format("YYYY-MM-DD");
        } catch (e) {
            user.birth = null;
        }

        this.data.user = user;
        this.data.group = group;
        this.data.password = {}

        await this.service.render();
    }

    public async update() {
        let userinfo = JSON.stringify(this.data.user);
        const { code, data } = await wiz.call("update", { userinfo });
        if (code == 200) {
            this.alert("저장되었습니다", 'success');
            await this.load();
            return;
        }

        await this.alert("오류가 발생했습니다");
    }

    public async changePassword() {
        let pdata = JSON.parse(JSON.stringify(this.data.password));

        if (pdata.data != pdata.repeat) {
            await this.alert("변경 비밀번호를 다시 확인해주세요");
            return;
        }

        let pd = {};
        pd.current = this.service.auth.hash(pdata.current);
        pd.data = this.service.auth.hash(pdata.data);

        const { code, data } = await wiz.call("change_password", pd);

        if (code != 200) {
            await this.alert(data);
            return;
        }

        location.href = "/auth/logout";
    }

}

export default PageMydeskMypageComponent;